import { AxiosRequestConfig, AxiosResponse } from 'axios';

// TODO
// Improtant! If the path has depth (includes "/"), then you need to create each nesting node as a separate folder and create a json file in the nested folder itself. 
// json file should not have "?" symbol. This symbol must be replaced with "_".
// Then you need to add a new entry in convertPaths for the relationship between the request path and the file location path

const convertPaths: { [key: string]: string } = {
  'file-data/calc?dataType=brief': 'file-data/calc_dataType=brief',
  'file-data/calc?dataType=converter': 'file-data/calc_dataType=converter',
  'file-data/calc?dataType=finder_products': 'file-data/calc_dataType=finder_products',
  'file-data/calc?dataType=finder_plants': 'file-data/calc_dataType=finder_plants',
  'file-data/croptimizer?tag=soils': 'file-data/croptimizer_tag=soils',
  'file-data/croptimizer?tag=products': 'file-data/croptimizer_tag=products',
  'file-data/croptimizer?tag=mineralization': 'file-data/croptimizer_tag=mineralization',
  'file-data/croptimizer?tag=efficiency': 'file-data/croptimizer_tag=efficiency',
  'file-data/croptimizer?tag=crops': 'file-data/croptimizer_tag=crops',
};

export interface IOfflineGet {
  <T = any, R = AxiosResponse<T>>(url: string): Promise<R>;
  get<T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<R>;

}

async function offlineGet(path: string, config?: any) {
  try {
    const files = import.meta.glob('/public/static-responses/**/*.json', { eager: true });

    const data = files[`/public/static-responses/${convertPaths?.[path] || path}${config?.params?.blueLang || ''}.json`];
    const response = {
      data,
    };

    return response;
  } catch (error: any) {
    console.log('offlineGet error', error);

    return error;
  }
}
function offlineClient(path: string, config?: any) {
  return offlineGet(path, config);
}

offlineClient.prototype.get = offlineGet;

export default offlineClient as IOfflineGet;